import type { JSX } from 'react';

import { Image } from '@change-corgi/design-system/components/media';

type Props = Readonly<{
	id: string;
	url: string;
	mobileUrl: string;
}>;

export function Photo({ id, url, mobileUrl }: Props): JSX.Element {
	return (
		<Image
			fetchPriority="high"
			// The ratio we generate from uploaded images
			aspectRatio="25/14"
			fit="cover"
			width="100%"
			id={id}
			src={[mobileUrl, url]}
			alt=""
			sx={{
				borderRadius: 'standard',
				// removes an unwanted padding under the image
				verticalAlign: 'top',
			}}
		/>
	);
}
